module.exports = __webpack_public_path__ + "media/images/icons/bang-297ce8dd97d121d68ac4ce9bf9831692.svg";